import React from 'react';
import { colorType, withTheme } from '../styling/theme';

const CheckIcon = ({ grayColor }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      fill={grayColor.hex}
      d="M8.2 14.4a.75.75 0 0 1-.53-.22L3.97 10.47a.75.75 0 1 1 1.06-1.06l3.17 3.17 6.77-6.77a.75.75 0 1 1 1.06 1.06l-7.3 7.31a.75.75 0 0 1-.53.22z"
    />
  </svg>
);

CheckIcon.propTypes = {
  grayColor: colorType,
};

CheckIcon.defaultProps = {
  grayColor: {},
};

const ThemedCheckIcon = withTheme(({ colors: { gray } }) => ({
  grayColor: gray,
}))(CheckIcon);

export default ThemedCheckIcon;
